// Copyright (c) Zammo Inc.
import React from 'react';
import { Components, Constants } from 'botframework-webchat';

import { Caption } from './styles';

const { connectDictationInterims } = Components;
const {
  DictateState: { DICTATING, STARTING },
} = Constants;

type Props = {
  className: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dictateInterims: any[];
  dictateState: string;
};

export default connectDictationInterims()(
  ({ className, dictateInterims, dictateState }: Props) =>
    (dictateState === STARTING || dictateState === DICTATING) &&
    !!dictateInterims.length && (
      <Caption className={className}>
        {dictateInterims.map((interim, index) => (
          <span key={index}>{interim}&nbsp;</span>
        ))}
      </Caption>
    )
);
